<div *ngIf="listo" class="destacados-container">
    <h2 class="titulo-destacados">Inmuebles destacados</h2>
    <div *ngIf="inmuebles.length > 0 && listo" id="carouselDestacados" class="carousel carousel-dark slide"
        data-bs-ride="carousel">
        <div class="carousel-inner">
            <div *ngFor="let grupo of destacados; let i = index" class="carousel-item"
                [ngClass]="{ 'active': i === 0 }">
                <div class="carousel-contenedor">
                    <div *ngFor="let inmueble of grupo" class="card inmueble-card">
                        <div *ngFor="let img of inmueble.imagenes">
                            <img *ngIf="img.principal == 1" src="{{img.ruta}}"
                                onerror="this.src='Inmuebles/assets/img/nd_cards.svg'" class="card-img-top" alt="..." />
                        </div>
                        <div *ngIf="inmueble.imagenes.length == 0">
                            <img src="Inmuebles/assets/img/nd_cards.svg" class="card-img-top" alt="" />
                        </div>
                        <div class="card-body">
                            <label class="inmueble-desc">{{ inmueble.tipoInmueble }} en {{ inmueble.estado }} - {{ inmueble.municipio }}</label>
                            <label class="inmueble-price" *ngIf="inmueble.precio === 1">En actualización</label>
                            <label class="inmueble-price" *ngIf="inmueble.precio !== 1">${{ inmueble.precio | number:'1.0-2' }} pesos</label>
                            <div class="inmueble-datos">
                                <label><b>Folio:</b> {{ inmueble.folio.slice(-5) }}</label>
                                <label><b>Tipo:</b> {{ inmueble.tipoInmueble }}</label>
                                <label><b>Subtipo:</b> {{ inmueble.subtipoInmueble }}</label>
                                <label><b>Estado:</b> {{ inmueble.estado }}</label>
                                <label *ngIf="inmueble.estatus == 0"><b>Estatus:</b> En regularización</label>
                                <label *ngIf="inmueble.estatus == 1"><b>Estatus:</b> En venta</label>
                                <label><b>Dimensiones:</b> {{ inmueble.metros | number:'1.0-2' }} m²</label>
                            </div>
                            <a (click)="detalleInmueble(inmueble.folio)" class="btn-detalle">Detalle de inmueble</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="carousel-controles">
            <button class="custom-arrow" (click)="moverCarrusel(-1)">
                <img src="Inmuebles/assets/iconos/chevron-left.svg" alt="Anterior" class="arrow-icon">
            </button>
        
            <div class="carousel-indicators carousel-indicators-custom">
                <button *ngFor="let grupo of destacados; let i = index" type="button" data-bs-target="#carouselDestacados"
                    [attr.data-bs-slide-to]="i" [ngClass]="{ 'active': i === 0 }" [attr.aria-label]="'Slide ' + (i + 1)">
                </button>
            </div>
        
            <button class="custom-arrow" (click)="moverCarrusel(1)">
                <img src="Inmuebles/assets/iconos/chevron-right.svg" alt="Siguiente" class="arrow-icon">
            </button>
        </div>
    </div>
    <!-- <div class="row" style="height: 250px;" *ngIf="esVacia">
        <div class="col-sm-12 text-center">
            <img src="assets/iconos/advertencia.png" width="30" height="30" alt="">
            <p class="font-gm">No se encontraron resultados de Inmuebles Más destacados</p>
        </div>
    </div> -->
</div>